module.exports = __webpack_public_path__ + "img/4.e4db9100.jpg";